import actions, { ActionConstants } from './actions';
import reducer from './reducers';
export const isLoading = require('./components/isLoading').default;
export const withLoading = require('./components/withLoading').default;
export * from './selectors';

export const loadingOverlayReducer = reducer;
export const LoadingOverlayActionConstants = ActionConstants;
export const LoadingOverlayActions = actions;
export default actions;



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/index.js